import classNames from 'classnames'
import mobileTabsStyle from 'subscription-flow/components/PurchaseFlowHeader/styles.module.scss'
import styles from '../styles.module.scss'

const NewSurveyTabs = ({ activeTab, surveyStepsFlow, onStepClick }) => (
    <div className="d-flex justify-content-center">
        <div className="d-flex">
            {surveyStepsFlow.map((step, index) => (
                <div
                    key={index}
                    className={classNames(mobileTabsStyle.progressStep, styles.progressStep, {
                        [mobileTabsStyle.active]: activeTab === index,
                    })}
                    onClick={() => onStepClick(index)}>
                    <div className={mobileTabsStyle.stepDescription}>
                        <span className={classNames(mobileTabsStyle.stepNumber)}>{index + 1}</span>
                        <span className={classNames(mobileTabsStyle.stepName)}>
                            <T>{step}</T>
                        </span>
                    </div>
                </div>
            ))}
        </div>
        <div className={mobileTabsStyle.stepLine}></div>
        <div>
            <span className={mobileTabsStyle.stepNameXC}>{surveyStepsFlow[activeTab]}</span>
        </div>
    </div>
)

export default NewSurveyTabs
